import HubConnection from '@/components/layout/hubConnection'
import { AppShell, Group, Space } from '@mantine/core'
import { menus } from './menu'
import { MobileMenu } from './mobileMenu'
import { SearchMenu } from './searchMenu'
import HeaderMenu from './topMenu'
import UserMenu from './userMenu'

interface ShellWithErrorProps {
  children: React.ReactNode
}

export function ShellWithError({ children }: ShellWithErrorProps) {
  return (
    <AppShell
      header={{
        height: {
          xs: 60,
          base: 60,
        },
      }}
    >
      <AppShell.Header bg="#405D72">
        <Group align="center" h="100%" px="md" justify="space-between">
          <Group>
            <MobileMenu menus={menus} />
            <Group visibleFrom="md">
              <HeaderMenu menus={menus} />
            </Group>
          </Group>
          <Group align="center" gap="xs">
            <SearchMenu />
            <UserMenu />
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar m="2">
        <HubConnection />
      </AppShell.Navbar>

      <AppShell.Main>
        <Space h="md" />
        {children}
      </AppShell.Main>
    </AppShell>
  )
}
